import styled from "styled-components";

export const SRListing = styled.div`
    border: 1px #DDDDDD solid;
    border-radius: 4px;
    table{
        width: 100%;
        border-collapse: collapse;
    }
    table th{
        border-bottom: 1px #DDDDDD solid;
        font-size: 12px;
        font-weight: 700;
        color: #9B9B9B;
        padding:6px 40px 6px 0;
        text-align: left;
    }
    table th:first-child{
        padding-left: 24px;
    }
    table td{
        border-bottom: 1px #DDDDDD solid;
        padding: 6px 40px 6px 0;
    }
    table tr td:first-child{
        padding-left: 24px;
    }
`;
export const ListText = styled.p`
    font-size: 12px;
    line-height: 16px;
    color: #000;
    word-break: break-word;
`;
export const ListStatusText = styled.p`
    min-width: 115px;
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    color: #000;
`;
export const ListSmallText = styled.p`
    font-size: 12px;
    line-height: 16px;
    color: #9B9B9B;
`;
export const ListStatus = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: 4px;
    ${p => p.status === 'submitted' && `
        background: linear-gradient(225deg, #F84F19 0%, #F3C852 100%);
    `}
    ${p => p.status === 'rejected' && `
        background: linear-gradient(67.62deg, #E14343 0%, #B52A2A 58.33%);
    `}
    ${p => p.status === 'accepted' && `
        background: linear-gradient(67.62deg, #43E1A8 0%, #219393 58.33%);
    `}
`;